import { SimpleGrid, Stack, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface Row {
  label: string;
  value: ReactNode;
}

export const LabelValueGrid = ({ rows }: { rows: Row[] }) => (
  <SimpleGrid columns={{ base: 1, sm: 2 }} spacingX="6" spacingY="4">
    {rows.map((row, index) => (
      <Stack key={`${row.label}-${index}`} spacing="1">
        <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
          {row.label}
        </Text>
        <Text color="smText" fontSize="sm">
          {row.value}
        </Text>
      </Stack>
    ))}
  </SimpleGrid>
);
